import { FormControl } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const StyledSelect = styled(FormControl, {})(({ fullWidth }) => ({
  width: fullWidth ? '100%' : 'calc((100% - 110px) / 4)',

  borderRadius: 0,

  '& .Mui-focused': {
    border: 'none',
  },

  '& label.Mui-focused': {
    color: theme.palette.fontgrey,
  },

  '& .MuiOutlinedInput-root': {
    borderRadius: 0,

    '&.Mui-focused fieldset': {
      borderColor: theme.palette.newSecondary,
    },
  },

  '& .MuiCheckbox-root.MuiCheckbox-colorPrimary.Mui-checked': {
    color: theme.palette.newSecondary,
  },
}));
